const routes = {
  landing: '/landing',
  about: '/about',
  works: '/works',
  project: '/project/:projectName',
  contact: '/contact',
  playground: '/playground',
};

export default routes;